<template>
  <div>
    <v-row>
        <v-col cols="12" class="py-0">
            <v-card
            style="border-radius: 0px;"
            flat>
                <div style="background: var(--color-primary)">
                    <v-card-title class="subtitle-2 white--text">
                    Proses Bangun
                    </v-card-title>
                    <v-card-subtitle class="white--text line-text-first pt-2 d-flex align-center caption">
                    Bagian ini untuk mengelola pembayaran tempo sesuai proses bangun.
                    </v-card-subtitle>
                </div>
            </v-card>
        </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";

  export default {
    data () {
      return {
        selected: {
        },
        dialog: {
          form: false,
          success: false
        },
        images: false,
        list: [],
        pagination: {},
        form: {
        },
        process: {
          run: false,
          form: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    components: {
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
    },
    props: [
      'booking'
    ],
    mounted () {
      this.fetch()
    },
    methods: {
      fixedNumber(value) {
        return Number.parseFloat(value).toFixed(0)
      },
      reset() {
        this.dialog.form = !this.dialog.form ? true : false

        this.process.form = false

        this.error.message = ''
      },
    }
  }
</script>